import * as preact from "preact";
import PropTypes from "prop-types";

import Checkbox from "../../Checkbox";

import classname from "../../../foundation/utils/classname";

import "./style.css";

class MultiSelectableListViewItem extends preact.Component {
    handleClick = () => {
        const { value, onClick } = this.props;

        onClick(value);
    }

    handleHover = () => {
        const { value, onHover } = this.props;

        onHover(value);
    }

    render() {
        const {
            label,
            subLabel,
            description,
            isSelected,
            isActive
        } = this.props;

        return (
            <label
                class={classname("multiSelectableListViewItem", { active: isActive })}
                onMouseEnter={this.handleHover}>
                <Checkbox checked={isSelected} onChange={this.handleClick}/>
                <div class="labelAndDescriptionContainer">
                    <div class="label">
                        <span class="labelText ellipsis">{label}{Boolean(subLabel) && ","}</span>
                        {Boolean(subLabel) && <span class="subLabelText">{subLabel}</span>}
                    </div>
                    {Boolean(description) && <p class="description">{description}</p>}
                </div>
            </label>
        );
    }
}

MultiSelectableListViewItem.propTypes = {
    value: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    subLabel: PropTypes.string,
    description: PropTypes.node,
    isSelected: PropTypes.bool.isRequired,
    isActive: PropTypes.bool.isRequired,
    onClick: PropTypes.func.isRequired,
    onHover: PropTypes.func.isRequired
};

export default MultiSelectableListViewItem;
